import { apiCall, apiCallAdmin } from "../../services/api-service";

export const getTripPlanRouteApi = async (tripId) => {
  try {
    var payload = { table_name: "transport_trips", id: tripId };
    const response = await apiCallAdmin("POST", "get_gmap_direction", payload);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getTripHistoryRouteApi = async (tripId) => {
  try {
    var payload = { table_name: "transport_trip_history", id: tripId };
    const response = await apiCallAdmin("POST", "get_gmap_direction", payload);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const fetchActualRouteApi = async (tripId) => {
  try {
    var payload = { trip_id: tripId };
    const response = await apiCall("POST", "fetch_actual_route", payload);
    console.log("fetchActualRouteApi response:", response);
    return response;
  } catch (err) {
    console.error("Error fetching actual route:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getStopLocationsApi = async (id) => {
  try {
    const response = await apiCall("GET", `get_trip/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getDeliveryLocationsApi = async (id) => {
  try {
    const response = await apiCall("GET", `get_actual_plot/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getStopsListApi = async (id, status, term) => {
  try {
    const response = await apiCall("GET", `get_status_stops/${id}`, null, {
      params: { status: status, search: term },
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getLiveVehiclesApi = async (status) => {
  try {
    const response = await apiCall("GET", "get_trips", null, {
      params: { status: status },
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
